import { TableEditRow } from '@devexpress/dx-react-grid-material-ui';
import { CellComponent } from '../CellComponent/CellComponent';
import { styled } from '@mui/material/styles';

const StyledTableEditCell = styled(props => {
  return <TableEditRow.Cell {...props} />;
})(({ theme, customStyle }) => ({
  borderRight: '1px solid rgba(224, 224, 224, 1)',
  padding: '10px',
  '& > div::before': { borderBottom: '1px dashed red' },
  ...(customStyle || {})
}));

function EditRowCustomCellComponent({ ...props }) {
  const { EditFormatter, disableEdit } = props.column;

  if (!!EditFormatter) {
    return (
      <CellComponent {...props}>
        <EditFormatter isEditing={true} {...props} />
      </CellComponent>
    );
  }
  if (disableEdit) {
    return <CellComponent {...props} />;
  }
  return <StyledTableEditCell {...props} />;
}
export default EditRowCustomCellComponent;
